<div bsModal #modal="bs-modal" class="modal patient-selfevaluation-modal fade" tabindex="-1" role="dialog" aria-hidden="false">
    <div *ngIf="!activeQuestionnaireId" class="modal-dialog">
        <ng-container *ngIf="!formLoading">
            <div class="modal-content">
                <div *ngIf="queryParams && queryParams['modalTitle']" class="modal-header">
                    <span *ngIf="!queryParams['disableBack']" class="modal-header--goback" (click)="router.navigate(['/patients/edit/' + this.patientId] , {queryParams: { modalTitle: 'Update Patient', status: 'Activated' }})">
                        <i class="fas fa-arrow-left"></i>
                        {{ 'Back to Patient profile' | translate }}
                    </span>
                    <h4 class="modal-title">
                        <ng-template [ngIf]="isSendReminder" [ngIfElse]="createNewTitle">
                            {{ activeSEType.title | translate }}
                        </ng-template>
                        <ng-template #createNewTitle>
                            <!-- {{ JSON.stringify(activeSEType) }}; -->
                            {{ activeSEType.createTitle | translate }}
                        </ng-template>
                    </h4>
                    <button type="button" class="btn btn-link fal fa-times close" (click)="hideModal()" aria-label="Close"></button>
                </div>
                <div class="modal-body patient-form mat-form">
                    <form [formGroup]="form" class="mat-form" novalidate>
                        <div *ngIf="errorMessage.length > 0" class="row form-group" role="alert">
                            <div class="col-sm-10">
                                <div class="alert alert-danger">
                                    <div *ngFor="let error of errorMessage">
                                        <i class="fas fa-exclamation-circle" aria-hidden="true"></i> {{ error | translate }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="successMessage" class="row form-group" role="alert">
                            <div class="alert alert-info">
                                {{ successMessage | translate }}
                            </div>
                        </div>
                        <div class="row">
                            <ng-container *ngFor="let seType of SETypes">
                                <div *ngIf="!seType.disabled" class="col-xs-4">
                                    <div class="se-type se-type--{{seType.name}}"
                                         [class.active]="seType.type === activeSEType.type"
                                         (click)="changeSEType(seType)">
                                        <span class="se-type--label">{{ seType.label | translate }}</span>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                        <!--    START QUESTIONNAIRE -->
                        <ng-container *ngIf="activeSEType.type === 'se_di'">
                            <div class="row mr-t--md" *ngIf="activeSEType.type === 'se_di'">
                                <div class="form-group col-xs-12">
                                    <button (click)="isCollapsed = !isCollapsed"
                                            class="btn btn-gray btn-icon collapse-button"
                                            type="button ">
                                    <span *ngIf="isCollapsed">
                                        <i class="fas fa-angle-right"></i>{{ 'More Options' | translate }}
                                    </span>
                                        <span *ngIf="!isCollapsed">
                                        <i class="fas fa-angle-up"></i>{{ 'More Options' | translate }}
                                    </span>
                                    </button>
                                </div>
                                <div *ngIf="!isCollapsed">
                                    <div class="form-group col-xs-12" [class.disabled-group]="isSendReminder || form.controls['is_repeated'].value" >
                                        <ng-container *ngTemplateOutlet="studyVersionTemplate; context: {form: form}"></ng-container>
                                    </div>
                                    <div class="form-group col-xs-12 form-group--checkbox" *ngIf="showRepeated" [class.disabled-group]="form.controls['is_study'].value">
                                        <ng-container *ngTemplateOutlet="repeatedVersionTemplate; context: {form: form}"></ng-container>
                                    </div>
                                    <div #emailFG class="form-group col-xs-8">
                                        <mat-form-field class="ps-content">
                                            <input type="email" matInput required [placeholder]="'Email Address' | translate" formControlName="email" (focus)="onInputFocused($event, emailFG, modalClassName, true)"/>
                                            <small class="form-text" [hidden]="form.controls.email.valid ||
                                                    (form.controls.email.pristine && !formSubmitted) ||
                                                    form.controls.email.disabled">
                                                {{ 'Require this format: name@company.com' | translate }}
                                            </small>
                                        </mat-form-field>
                                    </div>
                                    <div class="form-group col-xs-6">
                                        <div class="form-customized mat-form-field-wrapper {{ validateCssDueDate }}">
                                            <label>
                                                <span>{{ 'Due Date' | translate }}</span>
                                                <span class="required-marker"> *</span>
                                            </label>
                                            <my-date-picker required formControlName="due_date" class="kl-datepicker" placeholder="dd.mm.yyyy" [options]="dpkDueDateOptions"
                                                            (inputFocusBlur)="onDueDateFocusBlur($event)" (inputFieldChanged)="onDueDateInputChanged($event)">
                                            </my-date-picker>
                                            <div class="mat-input-underline mat-form-field-underline">
                                                <span class="mat-input-ripple mat-form-field-ripple"></span>
                                            </div>
                                            <small class="form-text" [hidden]="form.controls.due_date.valid || (form.controls.due_date.pristine && !formSubmitted) || form.controls.due_date.disabled">
                                                {{ 'Date format is dd.mm.yyyy' | translate }}
                                            </small>
                                        </div>
                                    </div>
                                    <div class="form-group col-xs-7 hidden">
                                        <ng-container *ngTemplateOutlet="selectTypeTemplate; context: {form: form}"></ng-container>
                                    </div>
                                    <div class="form-group col-xs-10" *ngIf="!form.controls['is_repeated'].value">
                                        <mat-form-field class="ps-content">
                                            <mat-select [placeholder]="'Email Template' | translate" required (selectionChange)="onSelectEmailTemplate2($event.value)">
                                                <mat-option *ngFor="let questionnaireEmailTemplate of questionnaireEmailTemplates" [value]="questionnaireEmailTemplate['id']">
                                                    {{ questionnaireEmailTemplate['title'] }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="form-group col-xs-10" *ngIf="form.controls['is_repeated'].value">
                                        <mat-form-field class="ps-content">
                                            <mat-select [placeholder]="'Email Template' | translate" required formControlName="template_translation_id" (selectionChange)="onSelectEmailTemplate2($event.value)">
                                                <mat-option *ngFor="let questionnaireEmailTemplate of repeatedQuestionnaireEmailTemplates" [value]="questionnaireEmailTemplate['id']">
                                                    {{ questionnaireEmailTemplate['title'] }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>

                            <div class="row" *ngIf="activeSEType.type === 'se_di'">
                                <label class="form-group col-xs-12">{{ 'Message' | translate }}</label>
                                <div class="col-xs-12">
                                    <app-tinymce #tinymce formControlName="content"></app-tinymce>
                                </div>
                                <div class="form-group hidden">
                                    <input formControlName="email_subject" type="text"/>
                                </div>
                            </div>

                        </ng-container>
                        <!--  /END  START QUESTIONNAIRE -->

                        <!--    SEND REMINDER   -->
                        <ng-container *ngIf="activeSEType.type === 'reminder'">
                            <div class="row mr-t--md">
                                <div class="form-group col-xs-12">
                                    <button (click)="isCollapsed = !isCollapsed"
                                            class="btn btn-gray btn-icon collapse-button"
                                            type="button">
                                    <span *ngIf="isCollapsed">
                                        <i class="fas fa-angle-right"></i>{{ 'More Options' | translate }}
                                    </span>
                                        <span *ngIf="!isCollapsed">
                                        <i class="fas fa-angle-up"></i>{{ 'More Options' | translate }}
                                    </span>
                                    </button>
                                </div>
                                <div *ngIf="!isCollapsed">
                                    <div class="form-group col-xs-12" *ngIf="!isRegisteredPatient" [class.disabled-group]="isSendReminder || form.controls['is_repeated'].value" >
                                        <ng-container *ngTemplateOutlet="studyVersionTemplate; context: {form: form}"></ng-container>
                                    </div>
                                    <div class="form-group col-xs-12" *ngIf="showRepeated" [class.disabled-group]="form.controls['is_study'].value">
                                        <ng-container *ngTemplateOutlet="repeatedVersionTemplate; context: {form: form}"></ng-container>
                                    </div>
                                    <div class="form-group col-xs-8" *ngIf="!isRegisteredPatient">
                                        <mat-form-field class="ps-content" [class.disabled-group]= "patient.email != null">
                                            <input type="email" [placeholder]="'Sending Reminder To' | translate"
                                                   formControlName="email"
                                                   matInput
                                                    />
                                            <small class="form-text" [hidden]="form.controls.email.valid || (form.controls.email.pristine && !formSubmitted)">
                                                {{ 'Email is invalid.' | translate }}
                                            </small>
                                        </mat-form-field>
                                    </div>

                                    <div class="form-group col-xs-6">
                                        <div class="form-customized mat-form-field-wrapper {{ validateCssDueDate }}">
                                            <label>
                                                {{ 'Due Date' | translate }}
                                            </label>
                                            <span class="required-marker"> *</span>
                                            <my-date-picker class="kl-datepicker" formControlName="due_date" required 
                                                            placeholder="dd.mm.yyyy" [options]="dpkDueDateOptions"
                                                            (inputFocusBlur)="onDueDateFocusBlur($event)" (inputFieldChanged)="onDueDateInputChanged($event)"
                                                            required></my-date-picker>
                                            <div class="mat-input-underline mat-form-field-underline">
                                                <span class="mat-input-ripple mat-form-field-ripple"></span>
                                            </div>
                                            <small class="form-text" [hidden]="form.controls.due_date.valid
                                            || (form.controls.due_date.pristine && !formSubmitted)
                                            || form.controls.due_date.disabled">
                                                {{ 'Date format is dd.mm.yyyy' | translate }}
                                            </small>
                                        </div>
                                    </div>
                                    <div class="form-group col-xs-10" *ngIf="!isRegisteredPatient">
                                        <mat-form-field class="ps-content">
                                            <mat-select formControlName="template_translation_id"
                                                        [placeholder]="'Email Template' | translate" 
                                                        required="required"
                                                        [(ngModel)]="selectedTemplateReminderId"
                                                        (selectionChange)="onSelectReminderTemplate()">
                                                <mat-option *ngFor="let emailReminderTemplate of emailReminderTemplates" [value]="emailReminderTemplate['id']">
                                                    {{ emailReminderTemplate['title'] }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="form.controls.content.dirty" class="row">
                                <div class="col-md-12">
                                    <a (click)="onRevertTemplateReminder()" class="btn btn-link pull-right">
                                        ({{ 'Discard changes' | translate }})
                                    </a>
                                </div>
                            </div>

                            <div class="row reminder" *ngIf="!isRegisteredPatient">
                                <label class="form-group col-xs-12">{{ 'Message' | translate }}</label>
                                <div class="col-sm-12">
                                    <app-tinymce formControlName="content"></app-tinymce>
                                    <small class="form-text text-danger" [hidden]="form.controls.content.disabled
                                                   || form.controls.content.valid
                                                   || (form.controls.content.pristine && !formSubmitted)">
                                        {{ 'Questionnaire link is missing: Please revert to the original template or insert a link for the questionnaire (via the editor), with the Title value: questionnaire-link, Url value: #.' | translate}}
                                    </small>
                                </div>
                            </div>
                        </ng-container>
                        <!--    /END SEND REMINDER   -->

                        <!--    STUDY VERSION FOR PDF & DIRECTLY    -->
                        <div class="row mr-t--sm mr-b--sm">
                            <ng-container *ngIf="activeSEType.type === 'local_se_di' || activeSEType.type === 'pdf_se_di'">
                                <div class="form-group col-xs-12" [class.disabled-group]="isSendReminder || form.controls['is_repeated'].value">
                                    <ng-container *ngTemplateOutlet="studyVersionTemplate; context: {form: form}"></ng-container>
                                </div>
                                <div class="form-group col-xs-12 form-group--checkbox" *ngIf="showRepeated" [class.disabled-group]="form.controls['is_study'].value">
                                    <ng-container *ngTemplateOutlet="repeatedVersionTemplate; context: {form: form}"></ng-container>
                                </div>
                                <div class="form-group col-xs-7 hidden">
                                    <ng-container *ngTemplateOutlet="selectTypeTemplate; context: {form: form}"></ng-container>
                                </div>
                            </ng-container>
                        </div>
                        <!--    /END STUDY VERSION FOR PDF & DIRECTLY    -->

                        <div class="row">
                            <div class="col-xs-12 text-xs-left">
                                <button *ngIf="type !== 'read'" type="button" class="btn btn-primary" (click)="submit(form.value, form.valid, true)">
                                    {{ activeSEType['action'] | translate }}
                                </button>
                                <button *ngIf="type === 'read'" type="button" class="btn btn-primary" (click)="deArchive(form.value, form.valid)">
                                    {{ 'Reactivate' | translate }}
                                </button>
                                <button type="button" class="btn btn-secondary badge-pill" (click)="hideModal()">
                                    {{ 'Cancel' | translate }}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </ng-container>
    </div>
</div>

<ng-template #selectTypeTemplate let-form="form">
    <div [formGroup]="form">
        <mat-form-field class="ps-content">
            <mat-select formControlName="custom_id" [placeholder]="'Self-report type' | translate">
                <mat-option *ngFor="let customId of customIds" [value]="customId['id']">
                    {{ customId['name_' + translate.currentLang ] }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</ng-template>

<ng-template #studyVersionTemplate let-form="form">
    <div [formGroup]="form">
        <mat-slide-toggle formControlName="is_study">
            {{ 'Study Version' | translate }}
            <ng-template #tolTemplate>
                <div innerHtml="{{ 'This setting is used to create the study and research version of the self-report. This is extensive and should only be selected if the patient has given a corresponding declaration of consent.' | translate }}" class="tooltip-study">
                </div>
            </ng-template>
            <i class="fas fa-info-circle"
               attr.name="{{ 'Edit' | translate }}"
               aria-hidden="true"
               [tooltip]="tolTemplate"
               containerClass="tooltip-study"
               placement="top"></i>
            <span class="mr-l--md" *ngIf="patientId && form.controls['is_study'].value">
            {{ 'Res. ID' | translate }}: <b>{{patientId}}</b>
            </span>
        </mat-slide-toggle>
    </div>
</ng-template>

<ng-template #repeatedVersionTemplate let-form="form">
    <div [formGroup]="form">
        <mat-slide-toggle formControlName="is_repeated">
            {{ 'Repeated measurement' | translate }}
            <ng-template #repeatedlTemplate>
                <div innerHtml="{{ 'When using the repeated measuring option, the structure of the survey is adapted to the previous survey: Statements that the patient previously agreed to are asked first. Statements relating to the distant past are not asked again.' | translate }}" class="tooltip-study">
                </div>
            </ng-template>
            <i class="fas fa-info-circle gray-500"
               attr.name="{{ 'Edit' | translate }}"
               aria-hidden="true"
               [tooltip]="repeatedlTemplate"
               containerClass="tooltip-study"
               placement="top"></i>
        </mat-slide-toggle>
    </div>
</ng-template>

<dialog-component #dialog></dialog-component>

<!--    CONFIRMATION TO ARCHIVE CURRENT QUESTIONNAIRE -->
<div bsModal #modalArchive="bs-modal" class="modal fade modal-confirmation" tabindex="-1" role="dialog" aria-hidden="true">
    <!-- archive || delete -->
    <div *ngIf="activeQuestionnaireId" class="modal-dialog modal-confirmation-dialog modal-sm">
        <div class="modal-content">
                <div class="modal-body text-xs-center">
                    <div class="row">
                        <div class="col-xs-12">
                            <div class="modal-icon">
                                <i class="fas fa-archive" aria-hidden="true"></i>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12 modal-title">
                            {{ 'For your information' | translate }}
                        </div>
                        <div class="col-xs-12 modal-content">
                            {{ 'For repeated Self-Reports, the previous assessment is being archived. However, it can still be edited afterwards.' | translate }}
                        </div>
                        <div class="col-xs-12 modal-description">
                        </div>
                    </div>
                    <div class="row">
                        <input (change)="showArchiveMessageFuture = !showArchiveMessageFuture" type="checkbox" id="continous-showing" [checked]="!showArchiveMessageFuture" />
                        <label for="continous-showing">{{ 'Do not show this information in the future' | translate }}</label>
                    </div>
                    <div class="row">
                        <div class="col-xs-12 text-xs-right">
                            <button *ngIf="!responseMessage" type="button" class="btn btn-primary" (click)="archiveQuestionnaires()">
                                {{ 'OK' | translate }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
    </div>
</div>
